import { AccountModule } from './helpers/account-helper'

const module = AccountModule({
	name: 'yotpoSmsBump',
	retrieveUrl: (companyId) => `api/company/${companyId}/yotpo-smsbump-account/`,
	removeUrl: (companyId, accountId) =>
		`api/company/${companyId}/yotpo-smsbump-account/${accountId}/`,
	createUrl: (companyId) => `api/company/${companyId}/yotpo-smsbump-account/`,
})

module.actions.partialUpdate = async function ({ state, commit }, { companyId, data }) {
	try {
		const res = await useNuxtApp().$api(
			`api/company/${companyId}/yotpo-smsbump-account/${state.account.id}/`,
			{
				method: 'PATCH',
				body: data,
			},
		)

		if (res) {
			commit('assign', { companyId, data: res })
			return res
		}
	} catch (err) {
		commit('clear')
		throw err
	}
}

export default module
